import { shiftMarketplaceApi } from '../api/shift-marketplace'

export const {
  useGetAvailableShiftsQuery,
  useClaimShiftMutation,
  useGetMyShiftsQuery,
  useReleaseShiftMutation,
  useAdminClaimShiftMutation,
  useCheckShiftConflictsQuery,
} = shiftMarketplaceApi
